import { render, staticRenderFns } from "./TableFilterResend.vue?vue&type=template&id=22080eee"
import script from "./TableFilterResend.vue?vue&type=script&lang=js"
export * from "./TableFilterResend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports